const searchStrip = {
  hotels: "Hotéis", // translated
  city: "Cidade", // translated
  checkIn: "Check-in", // translated
  checkOut: "Verificação de saída", // translated
  date: "Encontro", // translated
  persons: "Pessoas", // translated
  adults: "Adultos", // translated
  rooms: "quartos", // translated
  editSearch: "Editar pesquisa", // translated
  newSearch: "Nova pesquisa", // translated
  listView: "Exibição de lista", // translated
  mapView: "Visão do mapa", // translated
};


export default searchStrip;
